<template>
  <div class="writer-box writer-bg">
    <HeadNavWriter />

    <div class="writer-box-content">

      <!-- steps -->
      <StepsWriter :active="3"/>

      <!-- elements -->
      <div class="preview-box">
        <div class="" style="font-weight: 600; font-size: 20px; color: #000000; line-height: 24px;margin-bottom: 1.5rem;">
          {{story.title}}
        </div>
        <div class="writer-box-content-editor global-box-scrollbar" v-html="replaceLineBreaks(texts.join('\n\n'))">

        </div>
      </div>
    </div>

    <!-- footer -->
    <div class="writer-box-footer" style="display: flex; justify-content: space-between;">
      <div style="display: flex; gap: 10px;" />
      <span class="button-group">
        <!-- <el-button class="custom-button" :size="$root.buttonSize" type="default" @click="goBack">返回修改</el-button> -->
        <el-button class="custom-button" :size="$root.buttonSize" type="outline" icon="el-icon-download" style="color: #0052D9; border-color: #0052D9;" @click="downloadFile2">{{ $i18n.locale === 'zh' ? '下载全文' : 'Download Full Text' }}</el-button>
      </span>

      <!-- <div style="position: relative;">
        <template v-if="!story.deliveryFlag">
          <el-button class="custom-button" :size="$root.buttonSize" type="primary" icon="el-icon-message" @click="onSubmission">投稿赚钱</el-button>
          <div class="submission-tips">
            <img src="@/assets/icon-tips.png" height="14" style="display: inline-block; margin-right: 0.1rem;position: relative;top: 0.1rem;">
            当前有 <span style="color: #0052D9;">{{ 10 }}</span> 家收稿方正在收稿，快来投稿吧！
          </div>
        </template>
        <el-button v-else-if="story.auditReason" class="custom-button" :size="$root.buttonSize" type="primary" icon="el-icon-upload2" @click="onSubmission">提交复审</el-button>
        <el-button v-else class="custom-button" :size="$root.buttonSize" type="primary" icon="el-icon-search" @click="gotoSubmissions(story.id)">查看投稿</el-button>
      </div> -->
    </div>

    <!-- 投稿成功 弹窗 -->
    <el-dialog
      :visible.sync="dialogSubmission"
      :show-close="true"
      width="500px"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="submission-success-dialog"
    >
      <div
        style="
          padding: 68px 68px 0 68px;
          text-align: center;
          background: #fff;
          border-radius: 20px;
        "
      >
        <div style="font-size: 20px; font-weight: bold; margin-bottom: 24px;">
          {{ $i18n.locale === 'zh' ? '恭喜投稿成功' : 'Congratulations on submitting successfully' }}
        </div>
        <div style="margin-bottom: 24px;">
          <img src="@/assets/submission-success.png" style="width: 80px; height: 80px;">
        </div>
        <div style="font-size: 16px; color: #333; margin-bottom: 86px;">
          {{ $i18n.locale === 'zh' ? '投稿成功！编辑将在3个工作日内回复～' : 'Submission successful! The editor will reply within 3 working days~' }}
        </div>
      </div>
      <div style="text-align: center; padding-bottom: 32px;">
        <el-button
          type="primary"
          style="width: 200px; height: 40px; font-size: 16px; border-radius: 8px;"
          @click="gotoSubmissions(story.id)"
        >
          {{ $i18n.locale === 'zh' ? '查看我的投稿' : 'View My Submissions' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import StepsWriter from '@/components/Steps4IdeaWriter'
import HeadNavWriter from '@/components/HeadNavWriter'
import LyRichEditor from '@/components/RichEditor'
import * as EnumApi from '@/api/enums'
import * as ArticleApi from '@/api/article'
import * as StoryContentApi from '@/api/storycontent'
import { mapState, mapMutations} from 'vuex'
import request from '@/utils/request'

export default {
  name: 'Article',
  components: {
    LyRichEditor, HeadNavWriter, StepsWriter
  },
  data() {
    return {
      enums: [],
      texts: [],
    	targetPermit: 'article',
      dialogSubmission: false
    }
  },
  computed: {
  	...mapState(['user', 'story', 'storyContents'])
  },
  mounted() {
     this.handlePageStoryContent()
  },
  methods: {
    gotoSubmissions(id) {
      window.submission_query_id = id
      this.$router.push(`/account/submissions`)
    },
    ...mapMutations(['setStory']),
    replaceLineBreaks(str) {
      return str?str.replace(/\\n/g, '\n').replace(/\n/g, '<br>'):"";
    },
    handleRemove(item) {
      let that = this;
      that.$confirm('', this.$i18n.locale === 'zh' ? '确定删除吗?' : 'Are you sure you want to delete?', {
        confirmButtonText: this.$i18n.locale === 'zh' ? '确定' : 'Confirm',
        cancelButtonText: this.$i18n.locale === 'zh' ? '取消' : 'Cancel',
        center: true
      }).then(() => {
        ArticleApi.remove(item.id).then(res => {

        });
      }).catch((e) => {console.log('error', e)});
    },
    handlePublish(item) {
      let that = this;
      let tip = !item.publishFlag?this.$i18n.locale === 'zh' ? '发布' : 'Publish' : this.$i18n.locale === 'zh' ? '取消发布' : 'Cancel Publish'
      that.$confirm('', this.$i18n.locale === 'zh' ? '确定'+tip+'吗?' : 'Are you sure you want to '+tip+'?', {
        confirmButtonText: this.$i18n.locale === 'zh' ? '确定' : 'Confirm',
        cancelButtonText: this.$i18n.locale === 'zh' ? '取消' : 'Cancel',
        center: true
      }).then(() => {
        ArticleApi.published({id: item.id, enabled: !item.publishFlag}).then(res => {

        });
      }).catch((e) => {console.log('error', e)});
    },
    downloadFile() {
      const filename = this.story.title
      const text = this.story.content
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename + '.txt');

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    downloadFile2() {
      const filename = this.story.title
      const text = this.story.content
      var FileSaver = require('file-saver');
      var blob = new Blob([text], {type: "text/plain;charset=utf-8"});
      FileSaver.saveAs(blob, filename);
    },
    async onSubmission() {
      await request({
        url: `/auth-service/articles/delivery/${this.story.id}`,
        method: 'post',
        data: {
          articleEventType: 'DELIVERED'
        }
      })
      this.dialogSubmission = true
    },
    goBack() {
      this.$router.push('/workspace/genbyidea3');
    },
    handlePageStoryContent(){
      if(this.storyContents.length > 0) {
        this.storyContents.forEach((item, index) => {
          this.texts.push(item.content)
        })
      }else{
        StoryContentApi.page({storyId: this.story.id, size: 100}).then(res => {
          let result = res.data.data;
          if(res.data.code == 0){
            if(result.records.length > 0){
              // console.log('story contents', result.records);
              result.records.forEach((item, index) => {
                this.texts.push(item.content)
              })
              // console.log('texts', this.texts);
            }
          }
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.writer-box {

  &-content {


    &-editor {
      height: calc(100% - 4.5rem);
      overflow: auto;
      line-height: 1.5rem;
      font-weight: 400;
      font-size: 1rem;
      color: #000000;
    }
  }
}
.preview-box {
  background: #ffffff;
  padding: 2.5rem;
  margin-top: 2rem;
  height: calc( 100% - 5rem );
  border-radius: 20px;
  box-shadow: 2px 4px 7px 0px rgba(205,211,223,0.35);
}
@media screen and (max-width: 768px) {
  .preview-box {
    margin-top: 1rem;
    padding: 1rem;
    height: calc( 100% - 7rem );
  }
}

.submission-tips {
  font-size: 12px;
  line-height: 1rem;
  color: #242424;
  width: 8rem;
  padding: 0.5rem;
  background: #FFE8AB;
  border-radius: 0.5rem;
  position: absolute;
  top: -5rem;
  left: 0.5rem;
  z-index: 10;
  animation: popup 0.5s ease-out, shake 0.5s ease-in-out 0.5s 3, fadeOut 0.5s ease-in 9.5s forwards;
  &::after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 45%;
    width: 0.5rem;
    height: 0.5rem;
    border-top: 0.5rem solid #FFE8AB;
    border-right: 0.5rem solid transparent;
    border-left: 0.5rem solid transparent;
  }
}

@keyframes popup {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0) rotate(0deg);
  }
  25% {
    transform: translateX(-5px) rotate(-10deg);
  }
  75% {
    transform: translateX(5px) rotate(10deg);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
}

.submission-success-dialog /deep/ .el-dialog {
  border-radius: 20px!important;
  overflow: hidden;
}
</style>
